import { useEffect } from "react";
import { CockpitEmailPanel } from "./CockpitEmailPanel";

interface Props {
  onClose: () => void;
}

/**
 * EM-6 — host shell for the cockpit Email panel. The whole-inbox, focus-styled
 * view now lives in CockpitEmailPanel (reused inline after the layout swap);
 * this modal is just the temporary container + a close button. Esc closes.
 */
export function EmailWorkspaceModal({ onClose }: Props) {
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [onClose]);

  return (
    <div className="write-confirm-backdrop" role="dialog" aria-modal="true">
      <div className="write-confirm-card email-ws-card">
        <div className="email-ws-shell-top">
          <button className="email-detail-close" onClick={onClose} title="Close (Esc)">
            ✕
          </button>
        </div>
        <CockpitEmailPanel />
      </div>
    </div>
  );
}
